import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { LoadingApiService } from 'features/loading-log/api/loading-api.services';
import { UserListParams } from 'features/users';
import qs from 'qs';

import { LoadingQueryKeys } from './query-keys';
const { getLoading } = LoadingApiService();

const getUsersQuery = (
  params: UserListParams,
  options?: UseQueryOptions<any>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<any>;
} => ({
  queryKey: LoadingQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getLoading(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetLoadingList = (
  params: UserListParams,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();
     
  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};








